
import { defineComponent } from "vue";
import DesignerTitle from "@/views/formBuilder/components/DesignerTitle.vue";
import DesignerToolbar from "@/views/formBuilder/components/DesignerToolbar.vue";
import { IFormSections } from "@/interfaces/iForm";

export default defineComponent({
  name: "designer-header",
  components: { DesignerTitle, DesignerToolbar },
  emits: ["save-data", "toggle-is-template", "get-preview-data"],
  props: {
    designCreated: Boolean,
    formSection: {
      type: Object as () => IFormSections,
      required: true,
    },
    isPreview: { type: Boolean, default: false },
    isTemplate: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const controls = [];
    const emitSaveData = (data) => {
      emit("save-data", data);
    };
    const toggleIsTemplate = (data) => {
      emit("toggle-is-template", data);
    };

    const getPreviewData = (device) => {
      emit("get-preview-data", device);
    };
    return {
      controls,
      emitSaveData,
      toggleIsTemplate,
      getPreviewData,
    };
  },
});
